<div class="worksheet-context-menu">
  <div class="option">
    <span class="title">ABRIR FERRAMENTA</span>
  </div>
  <div class="option" *ngFor="let item of toolList">
    <hr>
    <span class="pointer" (click)="openNewTool(item)">{{item.title}}</span>
  </div>
</div>